import classNames from 'classnames'
import { getPbgidIcon, usePbgidIcons } from '../../helpers/pbgidIcons'

export function LiveGameLandmarkDisplay({ pbgid, count, inQueue, isUnique = false, leftSide, showCount = true, isKT = false }) {
	const icon = getPbgidIcon(usePbgidIcons(), parseInt(pbgid))
	console.log(isKT)

	return (
		<div className={classNames('h-[40px] flex', isKT ? 'w-[74px] ' : 'w-[40px] ', leftSide ? 'flex-row-reverse' : 'flex-row')}>
			{showCount && (
				<div className="w-[30px] bg-[#252525dc] flex flex-col">
					<h1
						className={classNames('h-5 px-1 text-[#b1b1b1] align-top -mt-[2px] italic', leftSide ? 'text-left' : 'text-right', inQueue === 0 ? 'opacity-0' : '')}
						style={{ textShadow: '2px 2px 3px black' }}>
						{inQueue}
					</h1>
					<h1 className={classNames('h-5 px-1 text-white align-top -mt-[2px] ', leftSide ? 'text-left' : 'text-right')} style={{ textShadow: '2px 2px 3px black' }}>
						{count}
					</h1>
				</div>
			)}
			<div
				className={classNames('relative', isKT ? 'w-[74px]' : 'w-[40px] ')}
				style={{
					backgroundImage: `url(/liveGameIcons/empty_background.png)`,
				}}>
				<img className={classNames('h-10', isKT ? 'w-[74px]' : 'w-10')} src={icon} alt="" />
				{isUnique && <img className="absolute bottom-0 left-0 w-4 h-4" src={`/liveGameIcons/unique.png`} alt="" />}
			</div>
		</div>
	)
}
